export const HOME = "/";
export const DESENGANCHE = "/Desenganche";
export const MENSUALIDADES = "/Mensualidades";
export const CONVENIOS = "/Convenios";
export const JURIDICAS = "/Pending";
export const LOGIN = "/admin";
export const REGISTRO = "/crearusuario";
export const ETHICSCHANNEL = "/ethicschannel";
export const BMANUAL = "/boleta";
export const SUPPORTDOC = "/supportdoc";
export const PDF = "/PDF";
export const CREDITNOTES = "/creditNotes";
